import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading, {
  canCancel: false,
  'is-full-page': false,
  backgroundColor: 'rgba(255,255,255,0.5)',
  color: '#ff9999',
  opacity: 1,
});

export default Loading;
